import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
  timelineItemClasses,
} from "@mui/lab";
import { Typography } from "@mui/material";
import type {
  DeliveryRouteDestinationProps,
  DeliveryRouteProps,
} from "../model";
import { DeliveryRouteDestination } from "./delivery-route-destination";

export const DeliveryRoute = (props: DeliveryRouteProps) => {
  const baseOfferCargo = props.baseOfferCargo;
  const deliveryRouteDestinations: DeliveryRouteDestinationProps[] =
    baseOfferCargo
      ? baseOfferCargo.destinations.map<DeliveryRouteDestinationProps>(
          (baseDestination, index) => {
            const baseDeadlineDate = (() => {
              if (index === 0) {
                return baseOfferCargo.loadingOn;
              }
              if (index === baseOfferCargo.destinations.length - 1) {
                return baseOfferCargo.unloadingOn;
              }
              return undefined;
            })();
            const correspondingDiffDestination =
              props.diffOfferCargo?.destinations[index];
            const diffDeadlineDate = (() => {
              if (!props.diffOfferCargo) {
                return {};
              }
              if (index === 0) {
                return props.diffOfferCargo.loadingOn;
              }
              if (index === props.diffOfferCargo.destinations.length - 1) {
                return props.diffOfferCargo.unloadingOn;
              }
              return undefined;
            })();
            return {
              dotText: `${index + 1}`,
              content: { ...baseDestination, deadlineDate: baseDeadlineDate },
              diff: correspondingDiffDestination
                ? {
                    ...correspondingDiffDestination,
                    deadlineDate: diffDeadlineDate,
                  }
                : {},
            };
          },
        )
      : [];

  const contentsCount = deliveryRouteDestinations.length;
  return (
    <Timeline
      position="right"
      sx={{
        margin: 0,
        padding: 0,
        [`& .${timelineItemClasses.root}`]: {
          ":before": {
            flex: 0,
            padding: 0,
          },
        },
      }}
    >
      {deliveryRouteDestinations.map((deliveryRouteDestination, index) => {
        const { dotText, dotCircle = true } = deliveryRouteDestination;
        const isLast = contentsCount - 1 === index;
        return (
          <TimelineItem key={`${index}-${dotText}`}>
            <TimelineSeparator>
              <TimelineDot
                color="primary"
                sx={{
                  display: "flex",
                  margin: 0,
                  width: dotCircle ? "28px" : "48px",
                  height: "28px",
                  borderRadius: dotCircle ? "50%" : "24px",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography fontSize="16px" fontWeight={700}>
                  {dotText}
                </Typography>
              </TimelineDot>
              {!isLast && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent
              sx={{
                paddingTop: 0,
                paddingBottom: !isLast ? 4 : 0,
              }}
            >
              <DeliveryRouteDestination {...deliveryRouteDestination} />
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
};
